var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,8c0-.093-.013-.186-.038-.275l-1.172-4.099c-.61-2.135-2.588-3.626-4.808-3.626H6.017C3.797,0,1.82,1.491,1.209,3.626L.039,7.725c-.025,.089-.039,.182-.039,.275,0,1.012,.378,1.937,1,2.643v9.357c0,2.206,1.794,4,4,4h6c2.206,0,4-1.794,4-4V11.463c.376-.218,.714-.496,1-.82,.733,.832,1.806,1.357,3,1.357h1c.345,0,.68-.044,1-.127v11.127c0,.552,.447,1,1,1s1-.448,1-1V10.643c.622-.705,1-1.631,1-2.643Zm-13,14H5c-1.103,0-2-.897-2-2v-2H13v2c0,1.103-.897,2-2,2Zm2-6H3v-4.127c.32,.083,.655,.127,1,.127h1c1.194,0,2.266-.526,3-1.357,.734,.832,1.806,1.357,3,1.357h2v4Zm6-6c-1.103,0-2-.897-2-2,0-.552-.447-1-1-1s-1,.448-1,1c0,1.103-.897,2-2,2h-2c-1.103,0-2-.897-2-2,0-.552-.448-1-1-1s-1,.448-1,1c0,1.103-.897,2-2,2h-1c-.49,0-.94-.178-1.288-.471-.029-.029-.059-.056-.091-.082-.354-.337-.585-.802-.617-1.32l1.128-3.951c.366-1.281,1.552-2.176,2.885-2.176h.983v2c0,.552,.448,1,1,1s1-.448,1-1V2h6v2c0,.552,.447,1,1,1s1-.448,1-1V2h.982c1.332,0,2.519,.895,2.885,2.176l1.129,3.951c-.065,1.044-.936,1.874-1.996,1.874h-1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.1945562bda39c60f31e967b9bc5e307f.svg";
export { ForwardRef as ReactComponent };